import styled from "styled-components";
import { colors } from "utils";
import { pageTitleInset } from "./pageTitleInset";

export const Header = ({ title }) => {
  if (!title) return null;
  return <Bar>{title}</Bar>;
};

const Bar = styled.div`
  background-color: ${colors.nightlyWoods500};
  color: ${colors.milkGlass500};
  font-size: 40px;
  font-weight: 700;
  line-height: 44px;
  padding-top: 24px;
  padding-right: 32px;
  padding-bottom: 24px;
  padding-left: ${pageTitleInset};
`;
